import { buildNavigationUrl } from "../../../util/buildNavigationUrl";
const ARTWORK_LIST_CONTEXT_KEYS = [
  "listId",
  "imageListId",
  "workingListId",
  "imageWorkingListId",
];

const getArtworkListContext = search => {
  const query = new URLSearchParams(search);

  return Object.fromEntries(
    ARTWORK_LIST_CONTEXT_KEYS.flatMap(key => {
      const value = query.get(key);
      return value ? [[key, value]] : [];
    }),
  );
};

const buildArtworkListUrl = ({ listContext = {}, status = "all" } = {}) => {
  const query = new URLSearchParams(
    status && status !== "all" ? { status } : {},
  );

  ARTWORK_LIST_CONTEXT_KEYS.forEach(key => {
    if (listContext[key]) query.set(key, listContext[key]);
  });

  return buildNavigationUrl("/artworks", query);
};

const buildArtworkNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
} = {}) =>
  buildNavigationUrl(
    `/artworks/${recordId}/${activeSubPage || "details"}`,
    buildArtworkListUrl({
      listContext,
      status,
    }).split("?")[1] || "",
  );

export {
  ARTWORK_LIST_CONTEXT_KEYS,
  buildArtworkListUrl,
  buildArtworkNavigationTargetUrl,
  getArtworkListContext,
};
